export const assetUrl = (u) => {
  if (!u) return '';
  if (u.startsWith('data:') || u.startsWith('http')) return u;
  return `${process.env.REACT_APP_BACKEND_URL}${u}`;
};
